if (!customElements.get('product-label')) {
  customElements.define(
    'product-label',
    class ProductLabel extends HTMLElement {

      constructor() {
        super();
        //console.log('product-label mounted')
      }

      connectedCallback() {
        // Retrieve and set input values from session storage
        this.populateInputValues();
      }

      populateInputValues() {
        console.log('populateInputValues')
        // Get input elements within the node
        const inputElements = this.querySelectorAll('input:not([type="file"]), textarea, select');

        // Loop through the input and select elements and populate their values
        inputElements.forEach((input) => {
          const storedValue = sessionStorage.getItem(input.id);
          if (storedValue !== null) {
            if (input.tagName.toLowerCase() === 'select') {
              // For select elements, set the selected option based on stored value
              const option = input.querySelector(`option[value="${storedValue}"]`);
              if (option) {
                option.selected = true;
              }
            } else {
              input.value = storedValue;
            }
          }
        });

        // Add event listeners to capture changes and store values
        inputElements.forEach((input) => {
          input.addEventListener('input', () => {
            if (input.tagName.toLowerCase() === 'select') {
              // For select elements, store the value of the selected option
              const selectedOption = input.options[input.selectedIndex];
              sessionStorage.setItem(input.id, selectedOption.value);
              //console.log(`Session storage for: ${input.id} set to: ${selectedOption.value}`)
            } else {
              sessionStorage.setItem(input.id, input.value);
              //console.log(`Session storage for: ${input.id} set to: ${input.value}`)
            }
          });
        });
      }

    }
  );
}
